const updatestateEvent = new Event('updatestate', {bubbles: true});

export function updateUrlParams(params = {}) {
    const url = new URL(window.location.href);
    const {searchParams} = url;

    for (const [key, value] of Object.entries(params)) {
        if (searchParams.has(key)) {
            searchParams.delete(key);
            searchParams.set(key, value);
        } else {
            searchParams.set(key, value);
        }
    }

    url.search = searchParams.toString();
    window.history.replaceState({}, document.title, url);
    window.dispatchEvent(updatestateEvent);
}

export function hasParam(param = '') {
    const url = new URL(window.location.href);
    const {searchParams} = url;

    return searchParams.has(param);
}

export function getParamValue(param = '') {
    const url = new URL(window.location.href);
    const {searchParams} = url;

    return searchParams.get(param);
}

export function removeParam(param = '') {
    const url = new URL(window.location.href);
    const {searchParams} = url;

    searchParams.delete(param);
    url.search = searchParams.toString();
    window.history.replaceState({}, document.title, url);
    window.dispatchEvent(updatestateEvent);
}

export function removeParams() {
    const url = new URL(window.location.href);
    const {searchParams} = url;

    for (const [key] of searchParams.entries()) {
        searchParams.delete(key);
    }

    url.search = searchParams.toString();
    window.history.replaceState({}, document.title, url);
    window.dispatchEvent(updatestateEvent);
}
